import styled from 'styled-components/macro'
import { Content } from './elements'

export const Gift = styled.section`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  max-width: ${props => props.theme.maxWidth};
  margin: auto;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`

export const GiftCode = styled.div`
  background-color: #fff;
  border-radius: ${props => props.theme.borderRadius};
  height: 40px;
  width: 100%;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${props => props.theme.padding};
  direction: rtl;
  position: relative;
  cursor: pointer;
`

export const GiftCodeLabel = styled.label`
  color: ${props => props.theme.colors.gray[0]};
  text-align: right;
  position: relative;
`

export const GiftCodeValue = styled.input`
  direction: ltr;
  text-align: center;
  border: none;
  outline: none;
  width: auto;
  cursor: text;
  font-size: .9rem;
  
  &::selection {
    color: #fff;
    font-weight: bold;
    background-color: ${props => props.theme.colors.darkOrange};
  }
`

export const GiftHeader = styled.section`
  width: 100%;
  padding: ${props => props.padding || props.theme.padding};
  background-color: ${props => props.backgroundColor};
  text-align: center;
  height: ${props => props.height};
  transition: all 0.5s ease-in-out;
  z-index: 2;
`

export const GiftHeaderText = styled(Content)`
  color: #fff;
  padding-bottom: ${props => props.theme.padding};
`

export const GiftLink = styled.a`
  color: ${props => props.theme.colors.orange};
  border-radius: 2px;
  display: block;
  width: fit-content;
  text-decoration: none;
  direction: ltr;
  text-align: right;
  padding: ${props => props.theme.padding} 0;

  &:hover {
    color: orange;
    text-decoration: underline;
  }
`

export const GiftBody = styled(Content)`
  padding: ${props => props.theme.padding};
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: space-between;
`

export const PaidGiftBody = styled(GiftBody)`
  padding-bottom: ${props => props.theme.padding};
`

export const UnPaidGiftBody = styled(GiftBody)`

`

export const PaidGiftHeader = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  width: 100%;
`

export const GiftDate = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
`

export const GiftDateContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #fff;
  width: 100%;
  padding: ${props => props.theme.halfSpace} 0;
  
  & > * {
    flex-grow: 1;
    flex-basis: 0;
  }
  & > :first-child:not(:last-child) {
    border-left: 1px solid #fff;
  }
`

export const GiftHint = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px;
  * {
    text-align: center;
  }
`

export const CopySucceed = styled.div`
  opacity: 0;
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 10px;
  padding: 4px 16px;
  color: ${props => props.theme.colors.green};
  position: absolute;
  top: 0px;
  left: 3.5px;
  height: 40px;
  
  &.animation {
    animation: fadeInOut 5s;
  }

  @keyframes fadeInOut {
    10% {
      opacity: 1;
      z-index: 10
    }
    95% {
      opacity: 1;
    }
    100%{
      opacity: 0;
      z-index: 10
    }
  }
`

export const GiftDateLabel = styled.label`
  padding-bottom: ${props => props.theme.halfSpace};

`

export const GiftDateValue = styled.span`

`

export const GiftInstruction = styled.section`
  margin: -${props => props.theme.margin};
  padding: ${props => props.theme.padding};
  background-color: ${props => props.theme.colors.gray[5]};
  border: 2px solid #fff;
  position: fixed;
  bottom: 0;
  left: auto;
  right: auto;
  width: 100%;
  max-width: 420px;
`

export const Subtitle = styled.div`

`

export const Title = styled.div`

`

export const GiftHeaderContent = styled.div`
  opacity: ${props => props.opacity};
  transition: opacity 0.5s ease-in-out;
`

export const VoucherGift = styled.div`
  color: green;
`